const RecentContentsColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { minWidth: 160, maxWidth: 200, px: 1.5, flex: 1, overflow: "hidden" } },
    },
    {
        id: "status",
        label: "Status",
        style: { custom: { minWidth: 100, maxWidth: 170, flex: 0.3 } },
    },
    {
        id: "owner",
        label: "Owner",
        style: { custom: { minWidth: 100, maxWidth: 170, flex: 0.3 } },
    },
    {
        id: "createdAt",
        label: "CreatedAt",
        style: { custom: { minWidth: 100, maxWidth: 170, flex: 0.3 } },
    },
];

const RecentVideosColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { minWidth: 160, maxWidth: 200, px: 1.5, flex: 1, overflow: "hidden" } },
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "status",
        label: "Status",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "owner",
        label: "Owner",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "createdAt",
        label: "CreatedAt",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
];

const AccessibleProjectsColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { minWidth: 160, maxWidth: 200, px: 1.5, flex: 1, overflow: "hidden" } },
    },
    {
        id: "isActive",
        label: "Status",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "ownerName",
        label: "Owner",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "access",
        label: "Access",
        style: { custom: { minWidth: 120, maxWidth: 120, flex: 0.3 } },
    },
];

const RecentSharedAssetsColumn = [
    {
        id: "sharedAssetName",
        label: "Name",
        style: { custom: { minWidth: 200, maxWidth: 200, px: 1.5, flex: 1, overflow: "hidden" } },
    },
    {
        id: "project",
        label: "Project",
        style: { custom: { minWidth: 140, maxWidth: 170, flex: 0.3 } },
    },
    {
        id: "granted",
        label: "Created",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "grantedBy",
        label: "",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
];

const RecentAssetsColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { minWidth: 200, maxWidth: 200, px: 1.5, flex: 1 } },
    },
    {
        id: "status",
        label: "Status",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "createdBy",
        label: "Owner",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "createdAt",
        label: "Created",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
];

const WeeklyAssetCountColumn = [
    {
        id: "range",
        label: "Statistics period",
        style: { custom: { minWidth: 200, maxWidth: 200, px: 1.5, flex: 1 } },
    },
    {
        id: "totalAssetCount",
        label: "Asset count",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "weeklyChange",
        label: "Weekly change",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
];

const WeeklyFileSizeColumn = [
    {
        id: "range",
        label: "Statistics period",
        style: { custom: { minWidth: 200, maxWidth: 200, px: 1.5, flex: 1 } },
    },
    {
        id: "totalSize",
        label: "Total Usage",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
    {
        id: "weeklyChange",
        label: "Weekly change",
        style: { custom: { minWidth: 100, maxWidth: 100, flex: 0.3 } },
    },
];

export {
    RecentContentsColumn,
    RecentVideosColumn,
    AccessibleProjectsColumn,
    RecentSharedAssetsColumn,
    RecentAssetsColumn,
    WeeklyAssetCountColumn,
    WeeklyFileSizeColumn,
};
